"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Invoice = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M12,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,6 C6,5.44771525 6.44771525,5 7,5 L12.7099045,5 L17,9.2995551 L17,10 L12,10 L12,6 L7,6 L7,19 L12,19 L12,20 Z M13,6.70710678 L13,9 L15.2928932,9 L13,6.70710678 Z M14,18 L15,18 C15,18.5522847 15.4477153,19 16,19 L17,19 C17.5522847,19 18,18.5522847 18,18 C18,17.4477153 17.5522847,17 17,17 L16,17 C14.8954305,17 14,16.1045695 14,15 C14,13.8954305 14.8954305,13 16,13 L16,12 L17,12 L17,13 C18.1045695,13 19,13.8954305 19,15 L18,15 C18,14.4477153 17.5522847,14 17,14 L16,14 C15.4477153,14 15,14.4477153 15,15 C15,15.5522847 15.4477153,16 16,16 L17,16 C18.1045695,16 19,16.8954305 19,18 C19,19.1045695 18.1045695,20 17,20 L17,21 L16,21 L16,20 C14.8954305,20 14,19.1045695 14,18 Z" })));
};
Invoice.displayName = 'Invoice';
exports.default = Invoice;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Invoice.js.map